<p-dialog [(visible)]="visibleCustomerManageDiscountDialog"
          [modal]="true"
          [style]="{ width: '700px' }"
          [draggable]="false"
          [resizable]="false"
          [closable]="true"
          (onHide)="cancel()">
    <ng-template pTemplate="item">
        <p-toast></p-toast>

        <p-dialog [modal]="true" [(visible)]="visibleConfirmDialog" [style]="{ width: '600px', height: '260px' }">
            <p class="special-confirm-title">{{activeActionConfirmBtn === actionBtnEnum.Update ? 'Overwrite New Special Discount?' : 'Remove Special Discount?'}}</p>

            <p class="special-confirm-description">{{activeActionConfirmBtn === actionBtnEnum.Update ? 'A special discount already exists. Are you sure you want to overwrite it with the new discount details? This action cannot be undone.' : 'Are you sure you want to remove this special discount? This action cannot be undone.'}}</p>

            <div class="flex justify-content-center gap-4 mb-2">
                <button pButton type="button" class="outlined-white-btn" label="Cancel" (click)="visibleConfirmDialog = false"></button>
                <button pButton type="button" class="{{activeActionConfirmBtn === actionBtnEnum.Update ? 'green-btn' : 'red-btn'}}" label="{{confirmBtnText}}" [loading]="showSpinner"
                        (click)="setSpecialDiscount()"></button>
            </div>
        </p-dialog>


        <span class="title-sdd block mb-4">Special Discount Details</span>
        <div>
            Use this popup to assign a discount (PWD, Senior Citizen, Student, Athlete or Coach) and update the status (Fully Verified, Not Verified, or Rejected). Confirm to apply changes and notify the user via email.
        </div>
        <div class="col-12 flex flex-row">
            <div class="col-6">
                <div class="flex flex-column">
                    <div class="filter-transaction-radiobtn-block mb-3">
                        <p-radioButton name="sdt" [value]="specialDiscountTypeEnum.PersonWithDisabilities" [(ngModel)]="specialDiscountType" inputId="sdt2"></p-radioButton>
                        <label for="sdt2" class="ml-2">Person With Disabilities</label>
                    </div>

                    <div class="filter-transaction-radiobtn-block mb-3">
                        <p-radioButton name="sdt" [value]="specialDiscountTypeEnum.Student" [(ngModel)]="specialDiscountType" inputId="sdt3"></p-radioButton>
                        <label for="sdt3" class="ml-2">Student</label>
                    </div>

                    <div class="filter-transaction-radiobtn-block mb-3">
                        <p-radioButton name="sdt" [value]="specialDiscountTypeEnum.SeniorCitizen" [(ngModel)]="specialDiscountType" inputId="sdt4"></p-radioButton>
                        <label for="sdt4" class="ml-2">Senior Citizens</label>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="flex flex-column">
                    <div class="filter-transaction-radiobtn-block mb-3">
                        <p-radioButton name="sdt" [value]="specialDiscountTypeEnum.Athlete" [(ngModel)]="specialDiscountType" inputId="sdt5"></p-radioButton>
                        <label for="sdt5" class="ml-2">Athlete</label>
                    </div>

                    <div class="filter-transaction-radiobtn-block mb-3">
                        <p-radioButton name="sdt" [value]="specialDiscountTypeEnum.Coach" [(ngModel)]="specialDiscountType" inputId="sdt6"></p-radioButton>
                        <label for="sdt6" class="ml-2">Coach</label>
                    </div>
                </div>
            </div>
        </div>

        <span class="title-vs block">Verification Status</span>
        <div class="col-12 flex flex-row">
            <div class="col-6">
                <div class="flex flex-column">
                    <div class="filter-transaction-radiobtn-block mb-3">
                        <p-radioButton name="sds" [value]="specialDiscountStatusEnum.FullyVerified" [(ngModel)]="specialDiscountStatus" inputId="sds2"></p-radioButton>
                        <label for="sds2" class="ml-2">Fully Verified</label>
                    </div>

                    <div class="filter-transaction-radiobtn-block mb-3">
                        <p-radioButton name="sds" [value]="specialDiscountStatusEnum.NotVerified" [(ngModel)]="specialDiscountStatus" inputId="sds3"></p-radioButton>
                        <label for="sds3" class="ml-2">Not Verified</label>
                    </div>

                    <div class="filter-transaction-radiobtn-block mb-3">
                        <p-radioButton name="sds" [value]="specialDiscountStatusEnum.Rejected" [(ngModel)]="specialDiscountStatus" inputId="sds4"></p-radioButton>
                        <label for="sds4" class="ml-2">Rejected</label>
                    </div>
                </div>
            </div>
        </div>

        <span class="title-vs block" *ngIf="specialDiscountStatus === specialDiscountStatusEnum.Rejected">Reject Reason</span>
        <div class="col-12 flex flex-row" *ngIf="specialDiscountStatus === specialDiscountStatusEnum.Rejected">
            <div class="col-6">
                <input type="text" pInputText [(ngModel)]="specialDiscountRejectReason" />
            </div>
        </div>

        <div class="flex justify-content-between gap-2 mt-2 mb-4">
            <div>
                <button pButton type="button" class="red-btn"
                        *ngIf="activeActionConfirmBtn !== actionBtnEnum.Add"
                        label="Remove Special Discount" (click)="openConfirmDialog(actionBtnEnum.Remove)"></button>
            </div>

            <div class="flex justify-content-end gap-2">
                <button pButton type="button" class="outlined-white-btn" label="Cancel" (click)="cancel()"></button>
                <button pButton type="button" class="bluedark-btn" label="Confirm" [loading]="showSpinner"
                        [disabled]="specialDiscountStatus === specialDiscountStatusEnum.None || specialDiscountType === specialDiscountTypeEnum.None"
                        (click)="activeActionConfirmBtn === actionBtnEnum.Add ? setSpecialDiscount() : openConfirmDialog(actionBtnEnum.Update)"></button>
            </div>
        </div>
    </ng-template>
    <ng-template #footer></ng-template>
</p-dialog>